/* globals true */

// As new widgets get added here, please also make sure they get added in
// webapp perseus/traversal.py so they can be properly translated.
module.exports = [[require("./widgets/radio.jsx"), true && require("./widgets/radio/editor.jsx")], [require("./widgets/input-number.jsx"), true && require("./widgets/input-number-editor.jsx")], [require("./widgets/numeric-input.jsx"), true && require("./widgets/numeric-input-editor.jsx")], [require("./widgets/expression.jsx"), true && require("./widgets/expression-editor.jsx")]];


/*****************
 ** WEBPACK FOOTER
 ** ./src/basic-widgets.js
 ** module id = 32
 ** module chunks = 0 2
 **/